import { Component, OnChanges, Input, SimpleChanges, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetails } from "../dasboard-admin-chart-details.model";
import { ChartValue } from "../chart/chart-value.model";
import { DateHelperService, ClaimsService } from '../../core/services';
import { LineChartOptions } from "../chart/line-chart-options.model";
import { IPublisher } from "../../shared/publisher.model";
import { FillBySourceService } from "./fill-by-source.service";
import { WebWorkerService } from 'angular2-web-worker/web-worker.service';

@Component({
    moduleId: module.id,
    selector: 'fill-by-source',
    templateUrl: 'fill-by-source.component.html'
})
export class FillBySourceComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetails;
    @Input() dataForToday: IDashBoardAdminChartDetails;
    @Input() period: string;
    @Input() showBottomSectionOverlay: boolean;
    toolTipText: string = "{2} {0} {1} ";

    chartValues: ChartValue[];
    triggerChange: Date;
    avgFill: number = 0;
    overAllFill: number = 0;
    chartOptions: LineChartOptions = new LineChartOptions();

    constructor(
        private dateHelper: DateHelperService,
        private fillBySourceService: FillBySourceService,
        private claimsService: ClaimsService,
        private webWorkerService: WebWorkerService) {
    }

    ngOnInit() {
        this.chartOptions.roundTooltip = true;
        this.chartOptions.tooltipSign = '%';
    }

    private mapAllData(): void {
        this.chartValues = new Array<ChartValue>();
        let publishers: IPublisher[] = new Array<IPublisher>();
        for (let item of this.data.fillBySource) {
            if (publishers.findIndex(s => s.id == item.publisher.id) == -1)
                publishers.push(item.publisher);
        }
        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = new ChartValue(publisher.name);
                chartValue.identifier = publisher.id;
                let fillBySources = this.data.fillBySource.filter(x => x.publisher.id == publisher.id);
                for (let item of fillBySources) {
                    chartValue.data.push([this.dateHelper.getTicks(item.dateUtc), item.fillPercentage]);
                    chartValue.lastItemIdentifier = item.dateUtc;
                }
                this.chartValues.push(chartValue);
            }
            this.avgFill = this.fillBySourceService.calculateAvgFill(this.data.fillBySource);
            this.overAllFill = this.fillBySourceService.calculateOverAllFill(this.data.fillBySource, this.data.totalRequests);
        }
    }

    private mapTodayData(params: any) {
        Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return o; o++ } return -1 } }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return i; o++ } } });
        let publishers = new Array();
        for (let item of params.dataForToday.fillBySource) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }

        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = params.chartValues.find(x => x.identifier == publisher.id);
                if (chartValue) {
                    let lastValue = chartValue.data[chartValue.data.length - 1];
                    let fillBySources = params.dataForToday.fillBySource.filter(x => x.publisher.id == publisher.id);
                    for (let item of fillBySources) {
                        if (formatDate(item.dateUtc) == formatDate(chartValue.lastItemIdentifier)) {
                            lastValue[1] = item.fillPercentage;
                        }
                    }
                }
                let todayPreviousData = params.data.fillBySource.find(s => s.publisher.id == publisher.id && isToday(s.dateUtc))
                if (todayPreviousData) {
                    let todayData = params.dataForToday.fillBySource.find(s => s.publisher.id == publisher.id);
                    if (todayData) {
                        todayPreviousData.contentReady = todayData.contentReady;
                        todayPreviousData.contentRequested = todayData.contentRequested;
                    }
                }
            }
        }
        function formatDate(date: Date) {
            let _date = new Date(date);
            let day = _date.getDate();
            let monthIndex = _date.getMonth();
            let year = _date.getFullYear();
            return year + '-' + monthIndex + '-' + day;
        }
        function isToday(date: Date) {
            return formatDate(date) === formatDate(new Date());
        }
        return params;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue) {
            this.mapAllData();
        }
        else
            if (this.dataForToday) {
                let params = {
                    dataForToday: this.dataForToday,
                    chartValues: this.chartValues,
                    data: this.data
                }
                if (typeof (Worker) !== "undefined") {
                    this.webWorkerService.run(this.mapTodayData, params).then((res) => {
                        this.onMapTodayData(res);
                    }).catch((r) => { console.log(r) });
                } else {
                    let res = this.mapTodayData(params);
                    this.onMapTodayData(res);
                }
            }

    }

    private onMapTodayData(res: any) {
        this.dataForToday = res.dataForToday;
        this.chartValues = res.chartValues;
        this.data = res.data;
        this.avgFill = this.fillBySourceService.calculateAvgFill(this.data.fillBySource);
        let totalRequests = this.data.totalRequests - this.data.totalRequestsForToday + this.dataForToday.totalRequestsForToday;
        this.overAllFill = this.fillBySourceService.calculateOverAllFill(this.data.fillBySource, totalRequests);
        this.data.totalRequestsForToday = this.dataForToday.totalRequestsForToday;
        this.triggerChange = new Date();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/fillbysource/fill-by-source.component.ts